import {wafProtectionService} from '@/services';

export function setBearerTokenIfExists(headers: Headers, token: string | null) {
  if (token) {
    headers.set('authorization', `Bearer ${token}`);
  }
  return headers;
}

export const setWafHeaders = async (
  url: string,
  headers: Headers,
): Promise<Headers> => {
  if (wafProtectionService.isModakUrl(url)) {
    const awsToken = await wafProtectionService.getWafToken();
    if (awsToken) {
      headers = wafProtectionService.getHeadersWithAwsToken(headers, awsToken);
    }
  }

  if (wafProtectionService.canSkipWaf(url)) {
    headers = wafProtectionService.getHeadersWithSkipWaf(headers);
  }

  return headers;
};
